import { render, staticRenderFns } from "./BERtable.vue?vue&type=template&id=91266d98&scoped=true"
import script from "./BERtable.vue?vue&type=script&lang=js"
export * from "./BERtable.vue?vue&type=script&lang=js"
import style0 from "./BERtable.vue?vue&type=style&index=0&id=91266d98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91266d98",
  null
  
)

export default component.exports